import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpXsrfTokenExtractor,
} from '@angular/common/http';

import { Observable } from 'rxjs';

@Injectable()
export class HttpXsrfInterceptor implements HttpInterceptor {
  private headerName = 'X-XSRF-TOKEN';

  public constructor(private tokenService: HttpXsrfTokenExtractor) {}

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let newReq = req;

    if (newReq.method === 'GET' || newReq.method === 'HEAD') {
      return next.handle(newReq);
    }

    const token = this.tokenService.getToken();

    // Be careful not to overwrite an existing header of the same name.
    if (token !== null && !newReq.headers.has(this.headerName)) {
      newReq = req.clone({
        headers: newReq.headers.set(this.headerName, token),
      });
    }

    return next.handle(newReq);
  }
}
